import Button from "@mui/material/Button";
import React, { useRef, useState } from "react";
import { IoMdClose } from "react-icons/io";
import { toast } from "react-toastify";
import { ToDoListService } from "../services/ToDoListService";
import useModalCloseHook from "../hooks/useModalCloseHook";

const AddNewTodo = ({onClose,setList}) => {
    const modalRef=useRef();
      useModalCloseHook(modalRef, onClose);
      const [newTask, setNewTask] = useState("");
      const [taskDate, setTaskDate] = useState(
        new Date().toISOString().split("T")[0]
      );

        const handleAddTask = async () => {
          if (!newTask.trim()) {
            toast.error("Task cannot be empty");
            return;
          }
      
          try {
            const data = { task: newTask, date: taskDate };
            const response = await ToDoListService.addToDo(data);
            if(response){
                setList((prev) => [...prev, response.data]);
            toast.success("Task added successfully");
            setNewTask("");
            setTaskDate("");
            onClose();
            }
          } catch (error) {
            toast.error(error?.message || "Failed to add task");
          }
        };
  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
      <div
        ref={modalRef}
        className="bg-white p-6 rounded-2xl w-[90%] max-w-lg shadow-lg relative"
      >
        <IoMdClose
          onClick={onClose}
          className="absolute cursor-pointer top-2 right-3 text-primary text-2xl hover:text-red-500"
        />

        <h2 className="text-2xl font-semibold text-zinc-800 mb-6 text-center">
          Add New Task
        </h2>

        <input
          type="text"
          placeholder="Enter task"
          value={newTask}
          onChange={(e) => setNewTask(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md mb-3 focus:outline-none"
        />
        <input
          type="date"
          value={taskDate}
          min={new Date().toISOString().split("T")[0]}
          onChange={(e) => setTaskDate(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md mb-4 focus:outline-none"
        />
        <Button
          onClick={handleAddTask}
          variant="contained"
          className=" btn-gradient !capitalize !w-full !p-2 !font-medium !text-white"
        >
          Add Task
        </Button>
      </div>
    </div>
  );
};

export default AddNewTodo;
